
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`La technologie utilisée, les protéines recombinantes, a fait ses preuves contre
d’autres maladies. Elle est maîtrisée, et peut donner un vaccin facile à stocker
et à transporter. Celui de Novavax peut être conservé entre 2 et 8 degrés. Cette
méthode est plus traditionnelle, ce qui est aussi un argument pour celles et
ceux qui ne veulent pas de l'ARNm.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;